import { useRouter } from 'next/router';
import CONFIG from '../config';

export const useShowFlexibleComponents = () => {
  const router = useRouter();
  const isShowFlexibleComponents = CONFIG.routesOnDesktop.includes(
    router.asPath.split('#')[0]
  );

  return { isShowFlexibleComponents };
};
